import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks'
import { SetId } from '../../../../../../redux/feature/SuscriptionSlice'
  
export default function GetSuscriptionSelector(props:any) {
   
    const Id = useAppSelector(state => state.SuscriptionSlice.id)
    const dispatch = useAppDispatch()
    const Type = useAppSelector(state => state.CloudSlice.Type)

    

    
    return(
        <div>
        <label className=' fw-bolder  fs-7 mb-0 '>Subscription</label>
              <select  
              style={{height:'auto',paddingTop:'0', paddingBottom:'0'}}
              disabled={Id === 0}
              onChange={e => dispatch(SetId(Number(e.target.value)))} value={Id} name= 'purchaseorder'className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example">
                 { Type === 'Global' &&  <option value="Not applicable">Not applicable</option> }
                {   props.sus?.map( (sus:any,i:any) =>
                    <option key={i} value={sus.id}>{sus.name}</option>
                    )
                  }
              </select>
        </div>
    )
  
}